/**
 * Formatting helpers for the holdings table.
 *
 * Kept out of Step3Holdings.tsx so that file exports only components — a module
 * that mixes the two disables Vite's Fast Refresh for every component in it.
 */

/** Format OCF as percentage string (e.g. 0.0022 → "0.22%") */
export function formatOcf(ocfPct: number | undefined): string {
  if (ocfPct == null) return '';
  return `${(ocfPct * 100).toFixed(2)}%`;
}
